import React from 'react';
var striptags = require('striptags');



class QuestionOptions extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            disabledNext:false,
            selectedAns:true,
            /*selectedResult:[],
            selectedAdditionalResult:[],*/
            selectedAnswer:'',
            selectedAnswerKey:'',
            selectedAdditionalAnswer:'',
            additionalSelectedAnswerKey:'',
        }

    }
    componentDidMount(){

    }

    _getSelectedResult(additional){
        /*console.log(this.props.multipleQ)*/
        if(this.props.multipleQ!="1") {
            /*console.log('mQ not 1')*/
            this.props.setResult(this.state.selectedAnswer,this.state.selectedAnswerKey);
            this.props.setAdditionalResult(this.state.selectedAdditionalAnswer,this.state.additionalSelectedAnswerKey);
        }else{
            /*console.log('mQ=1')*/
            if(additional){
                /*console.log('Additional Q')*/
                this.props.setAdditionalResult(additional)
            }else{
              /*  console.log('not Additional Q')*/
                /*console.log('selectedAnswer: '+this.state.selectedAnswer)
                console.log('selectedAnswrKey: '+this.state.selectedAnswerKey)*/
                this.props.setResult(this.state.selectedAnswer,this.state.selectedAnswerKey)
            }


        }
    }


    selectAnswer(e){
        /*e.target.toggleAttribute('checked')*/

        let elements  = this.resultAns.children;
        for(let i=0;i<elements.length;i++){
           /* console.log(e.target);
            console.log(elements[i])*/
            if(e.target === elements[i]){
                elements[i].setAttribute('checked',true)
                elements[i].setAttribute('class','col-options2 selected')
                this.setState({selectedAnswerKey:e.target.value});
                this.setState({selectedAnswer:elements[i].innerHTML});
                setTimeout(()=> {
                    this._getSelectedResult();
                },100)
            }else{

                elements[i].removeAttribute('checked')
                elements[i].setAttribute('class','col-options2')
               /* elements[i].removeClass('checked')*/

            }
        }
    }
    selectDreiAnswer(e){
        let elements  = this.resultDreiAns.children;
        for(let i=0;i<elements.length;i++){
            if(e.target === elements[i]){
                elements[i].setAttribute('checked',true)
                elements[i].setAttribute('class','col-options2 selected')
                this.setState({selectedAnswerKey:e.target.value});
                this.setState({selectedAnswer:elements[i].innerHTML});
                setTimeout(()=> {
                    this._getSelectedResult();
                },100)
            }else{
                elements[i].removeAttribute('checked')
                elements[i].setAttribute('class','col-options2')
            }

        }
    }
    _shuffle(option){
        for(var j, x, i = option.length; i; j = Math.floor(Math.random() * i), x = option[--i], option[i] = option[j], option[j] = x);
        return option;
    }
    render(){
        let quizOptions;
        if(this.props.frageOptions.length === 2){

            quizOptions = this.props.frageOptions.map((option,key)=>{
                let strippedOption = striptags(option[1]).toString();
                let id= parseInt(key)+1;

                /*console.log(this.state.selectedAns)*/
                    return (

                        <li
                            key={option[0]}
                            value={option[0]}
                            className="col-options2"
                            onClick={this.selectAnswer.bind(this)}
                            checked={false}
                        >
                            {strippedOption}
                        </li>


                    );
            });
        }else{
            quizOptions = this.props.frageOptions.map((option,key)=>{
                let strippedOption = striptags(option[1]).toString();
                let id= parseInt(key)+1;
                return (
                    <li
                        key={option[0]}
                        value={option[0]}
                        className="col-options3"
                        onClick={this.selectDreiAnswer.bind(this)}
                        checked={false}
                    >
                        {strippedOption}
                    </li>

                );
            });

        }
        if(this.props.frageOptions.length === 2) {
           /* let strippedOption1 = striptags(this.props.frageOptions[0]).toString();
            let strippedOption2 = striptags(this.props.frageOptions[1]).toString();*/
            return (
                <div className="questionOptions zweiOptions">
                    <ul  className="zweiUL" ref={input => {
                        this.resultAns = input;
                    }} >
                        {quizOptions}
                    </ul>
                </div>
            );
        }else{
            if(this.props.frageOptions[0][1].length> 20) {
                return (
                    <div className="questionOptions dreiOptionsFullWidth centered">
                        <ul ref={input => {
                            this.resultDreiAns = input;
                        }} >
                            {quizOptions}
                        </ul>
                    </div>
                );
            }else {
                return (
                    <div className="questionOptions dreiOptions">
                        <ul className="dreiUL" ref={input => {
                            this.resultDreiAns = input;
                        }} >
                            {quizOptions}
                        </ul>
                    </div>
                );
            }
        }

    }
}
export default QuestionOptions;
